import React from 'react'
import { makeStyles } from '@mui/styles'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import { allowedPositions } from '@/modules/base/components/texts/config'

const useStyles = makeStyles(theme => ({
  subtitle: {
    fontSize: '14px',
    lineHeight: (props) => props.lineHeight || '1.25em',
    color: '#50586c',
    display: 'block',
  },
  // eslint-disable-next-line mui-unused-classes/unused-classes
  left: { textAlign: 'left' },
  // eslint-disable-next-line mui-unused-classes/unused-classes
  center: { textAlign: 'center' },
  // eslint-disable-next-line mui-unused-classes/unused-classes
  right: { textAlign: 'right' },
}))

const SubTitle = (props) => {
  const { customClass = '', position = 'left', className = '', children } = props
  const classes = useStyles(props)
  return (
    <span className={clsx(classes.subtitle, classes[position], customClass, className)}>{children}</span>
  )
}

SubTitle.propTypes = {
  children: PropTypes.node,
  position: PropTypes.oneOf(allowedPositions),
  className: PropTypes.string,
  customClass: PropTypes.string,
  lineHeight: PropTypes.string,
}

export default SubTitle
